import { render, staticRenderFns } from "./SidebarCharts.vue?vue&type=template&id=3bf17a60&"
import script from "./SidebarCharts.vue?vue&type=script&lang=js&"
export * from "./SidebarCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports